import AppBar from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import React, { useState } from 'react'
import { styles } from './styles'
import BackIcon from '@material-ui/icons/ArrowBack'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { withContext } from '../../context'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Card,
  Table,
  Space,
  DatePicker
} from 'antd'
import { Container } from '../../shared.style'
import ReportCardItem from './ReportCardItem'
import { ButtonEx } from '../HeroLocations/index.style'
import axios from 'axios'
import { DATE, ENDPOINT } from '../../utils/constants'
import { useDeepEffect } from '../../utils/hooks'
import { isUndefined, isEmpty, some, isNull } from 'lodash'
import moment from 'moment'

import ReportBin from '../../assets/bin/report_bin.png'
import ReportBinStar from '../../assets/bin/report_binstar.png'
import ReportBinMap from '../../assets/bin/report_map.png'
import ReportBinCO2 from '../../assets/bin/report_co2.png'

const { RangePicker } = DatePicker

const Reports = ({ history: { goBack }, me }) => {
  const [form] = Form.useForm()
  const [filterOptions, setFilterOptions] = useState({
    size: 20,
    page: 0
  })
  const [reportData, setReportData] = useState({})
  const [transactionList, setTransactionList] = useState([])
  const [binList, setBinList] = useState([])
  const [categories, setCategories] = useState([])
  const [locationList, setLocationList] = useState([])
  const [transactionLoading, setTransactionLoading] = useState(false)
  const [categoryOption, setCategoryOption] = useState(false)
  const [binOption, setBinOption] = useState(false)
  const [locationOption, setLocationOption] = useState(false)
  const [date, setDate] = useState([moment(new Date()), moment(new Date())])
  // const [categorySelect, setCategorySelect] = useState(['all'])



  const fetchRecyclingReport = async () => {
    try {
      const res = await axios.get(ENDPOINT + `/bin/recycling-report`, {
        params: {
          heroId: me.id
        }
      })
      setReportData(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  const fetchBinReport = async (options) => {
    await setTransactionLoading(true)
    try {
      const res = await axios.get(ENDPOINT + `/bin/transaction`, {
        params: {
          ...options,
          heroId: me.id
        }
      })

      await setTransactionList(res.data)
      await setTransactionLoading(false)
    } catch (err) {
      await setTransactionLoading(false)
      console.log(err)
    }
  }

  const fetchMasterData = async () => {
    try {
      const resBin = await axios.get(ENDPOINT + `/bin/`, {
        params: {
          heroId: me.id
        }
      })
      const resLocation = await axios.get(ENDPOINT + `/bin/location`, {
        params: {
          heroId: me.id
        }
      })
      const rescategories = await axios.get(ENDPOINT + `/category/all`)

      await setBinList(resBin.data)
      await setLocationList(resLocation.data)
      await setCategories(rescategories.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchBinReport(filterOptions)
    fetchRecyclingReport()
    fetchMasterData()
  }, [])


  console.log(locationList)
  console.log(categories)

  async function onShowSizeChange(current, pageSize) {
    filterOptions.size = pageSize
    filterOptions.page = 0
    setFilterOptions(filterOptions)
    await fetchBinReport(filterOptions)
  }

  async function onChange(page) {
    filterOptions.page = page - 1
    setFilterOptions(filterOptions)
    await fetchBinReport(filterOptions)
  }

  function handleChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })

    if (isAll) {
      setCategoryOption(true)
      // setCategorySelect(['all'])
      form.setFieldsValue({
        category: ['all']
      })
    } else {
      setCategoryOption(false)
      // setCategorySelect(value)
    }
  }

  function handleBinChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })

    if (isAll) {
      setBinOption(true)
    } else {
      setBinOption(false)
    }
  }

  function handleLocationChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })

    if (isAll) {
      setLocationOption(true)
    } else {
      setLocationOption(false)
    }
  }

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => (
        <span>{filterOptions.page * filterOptions.size + index + 1}</span>
      )
    },
    {
      title: 'บาร์โค้ดสินค้า',
      dataIndex: 'barcode',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'สินค้า',
      align: 'center',
      render: (text, record) => {
        return record.name && record.brand ? (
          <span>{`${record.name} ${record.brand}`}</span>
        ) : (
          '-'
        )
      }
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'วัสดุที่ได้',
      dataIndex: 'materialName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ถังที่ทิ้ง',
      dataIndex: 'bin',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'สถานที่ทิ้งลงถัง',
      dataIndex: 'location',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ผู้ทิ้ง',
      dataIndex: 'user',
      align: 'center'
    },
    {
      title: 'วันที่ทิ้ง',
      dataIndex: 'datetime',
      align: 'center',
      render: (text, record) => {
        return moment(text).format('DD-MM-YYYY')
      }
    }
  ]

  const onFinish = async (values) => {
    filterOptions.keyword = values.keyword || undefined

    if (values.category) {
      if (values.category[0] === 'all') {
        filterOptions.category = categories
          .map((category) => category.id)
          .join()
      } else {
        filterOptions.category = !isUndefined(values.category)
          ? values.category.join()
          : undefined
      }
    }

    if (values.locationId) {
      if (values.locationId[0] === 'all') {
        filterOptions.locationId = locationList
          .map((location) => location.id)
          .join()
      } else {
        filterOptions.locationId = !isUndefined(values.locationId)
          ? values.locationId.join()
          : undefined
      }
    }

    if (values.binId) {
      if (values.binId[0] === 'all') {
        filterOptions.binId = binList.map((bin) => bin.id).join()
      } else {
        filterOptions.binId = !isUndefined(values.binId)
          ? values.binId.join()
          : undefined
      }
    }
    setFilterOptions(filterOptions)
    await fetchBinReport(filterOptions)
  }

  const onClear = async (e) => {
    e.preventDefault()
    setFilterOptions((prevState) => {
      prevState.size = 20
      prevState.page = 0
      prevState.binId = undefined
      prevState.locationId = undefined
      prevState.category = undefined
      prevState.keyword = undefined
      return prevState
    })
    form.resetFields()
    await fetchBinReport(filterOptions)
  }

  function onDateChange(date) {
    if (!isNull(date)) {
      setDate(date)
    } else {
      setDate([moment(new Date()), moment(new Date())])
    }
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => goBack()}>
            <BackIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" style={styles.grow}>
            รายงาน
          </Typography>
        </Toolbar>
      </AppBar>
      <Container>
        <Row style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row justify="end">
              <Space>
                <RangePicker
                  value={date}
                  onChange={onDateChange}
                  format={DATE.FORMAT}
                />
                <ButtonEx color="#6ebf4b" type="primary">
                  <a
                    href={
                      ENDPOINT +
                      `/bin/export?heroId=${me.id}&from=${moment(
                        date[0]
                      ).format(DATE.FORMAT)}&to=${moment(date[1]).format(
                        DATE.FORMAT
                      )}`
                    }
                    download>
                    Export Data
                  </a>
                </ButtonEx>
              </Space>
            </Row>
          </Col>
        </Row>
        <Row gutter={[8, 8]} style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <ReportCardItem
              title="จำนวนขยะที่ถูกทิ้งลงถังทั้งหมด"
              subtitle={`${reportData.recycleItemTotal} ชิ้น`}
              img={ReportBin}
            />
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <ReportCardItem
              title="ปริมาณคาร์บอนที่สามารถลดได้"
              subtitle={`${Number(reportData.co2).toFixed(2)} kCO2e/kg`}
              img={ReportBinCO2}
            />
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <ReportCardItem
              title="ถังที่มีผู้ทิ้งขยะมากที่สุด"
              subtitle={reportData.topBin}
              img={ReportBinStar}
            />
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <ReportCardItem
              title="สถานที่ที่มีผู้ทิ้งขยะมากที่สุด"
              subtitle={reportData.topLocation}
              img={ReportBinMap}
            />
          </Col>
        </Row>
        <Card style={{ marginBottom: 15 }}>
          <Form form={form} layout="vertical" colon={false} onFinish={onFinish}>
            <Row gutter={8}>
              <Col span={18}>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ค้นหาข้อมูลการทิ้งขยะ" name="keyword">
                      <Input placeholder="บาร์โค้ด ชื่อสินค้า ยี่ห้อสินค้า" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="หมวดของวัสดุ" name="category">
                      <Select
                        mode="multiple"
                        onChange={handleChange}
                        showArrow={true}>
                        <Select.Option value="all">ทั้งหมด</Select.Option>
                        {categories.map((category, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={category.id}
                              disabled={categoryOption}>
                              {category.name}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="สถานที่ของถัง" name="locationId">
                      <Select
                        mode="multiple"
                        onChange={handleLocationChange}
                        showArrow={true}>
                        <Select.Option value="all">ทั้งหมด</Select.Option>
                        {locationList.map((location, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={location.id}
                              disabled={locationOption}>
                              {location.name}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                    <Form.Item label="ถังที่ทิ้งขยะ" name="binId">
                      <Select
                        mode="multiple"
                        onChange={handleBinChange}
                        showArrow={true}>
                        <Select.Option value="all">ทั้งหมด</Select.Option>
                        {binList.map((bin, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={bin.id}
                              disabled={binOption}>
                              {bin.name}
                            </Select.Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <Form.Item label=" ">
                  <Space>
                    <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
                      ค้นหา
                    </ButtonEx>
                    <ButtonEx type="danger" onClick={(e) => onClear(e)}>
                      เคลียร์
                    </ButtonEx>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        {!isEmpty(transactionList) && (
          <Table
            scroll={{ x: 1200 }}
            rowKey={(record) => {
              return record.id
            }}
            bordered
            dataSource={transactionList.content}
            columns={columns}
            loading={transactionLoading}
            pagination={{
              current: !isUndefined(transactionList)
                ? transactionList.pageable.pageNumber + 1
                : 1,
              pageSize: transactionList.size,
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              onShowSizeChange: onShowSizeChange,
              onChange: onChange,
              total: transactionList.totalElements
            }}
          />
        )}
      </Container>
    </React.Fragment>
  )
}

export default compose(withRouter, withContext)(Reports)



// WEBPACK FOOTER //
// ./src/pages/Reports/index.js